<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-row :gutter="40" class="panel-group">
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <i class="card-panel-icon el-icon-money"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">当日邮件数</div>
              <count-to
                :start-val="0"
                :end-val="index_data.total"
                :duration="3000"
                class="card-panel-num"
              />
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <i class="card-panel-icon el-icon-s-order"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">未读邮件数</div>
              <count-to
                :start-val="0"
                :end-val="index_data.receive"
                :duration="3000"
                class="card-panel-num"
              />
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <i class="card-panel-icon el-icon-price-tag"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">当月应付费用</div>
              <count-to
                :start-val="0"
                :end-val="index_data.unpaid"
                :duration="3000"
                class="card-panel-num"
              />
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-shopping">
              <i class="card-panel-icon el-icon-wallet"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">当月已付费用</div>
              <count-to
                :start-val="0"
                :end-val="index_data.paid"
                :duration="3000"
                class="card-panel-num"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CountTo from "vue-count-to";

export default {
  components: {
    CountTo
  },
  data() {
    return {
      start_time: "",
      end_time: "",
      index_data: {
        total: 0,
        receive: 0,
        paid: 0,
        unpaid: 0,
      }
    };
  },
  methods: {
    //加载首页数据
    getData() {
      this.$ajax({
        loading:true,
        url: "/dashboard/index",
        data: {}
      })
      .then(data => {
        if(data.code != 200) {
          return this.$util.msg(data.msg, "error");
        }

        this.index_data = data.data;
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style scoped>
.panel-group {
  margin-top: 18px;
}
.panel-group .card-panel-col {
  margin-bottom: 32px;
}

.panel-group .card-panel-col .card-panel {
  height: 108px;
  cursor: pointer;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}

.panel-group .card-panel-col .card-panel:hover .card-panel-icon-wrapper {
  color: #fff;
}

.panel-group .card-panel-col .card-panel:hover .icon-people {
  background: #40c9c6;
}

.panel-group .card-panel-col .card-panel:hover .icon-message {
  background: #36a3f7;
}

.panel-group .card-panel-col .card-panel:hover .icon-money {
  background: #f4516c;
}

.panel-group .card-panel-col .card-panel:hover .icon-shopping {
  background: #34bfa3;
}

.panel-group .icon-people {
  color: #40c9c6;
}

.panel-group .icon-message {
  color: #36a3f7;
}

.panel-group .icon-money {
  color: #f4516c;
}

.panel-group .icon-shopping {
  color: #34bfa3;
}

.panel-group .card-panel-icon-wrapper {
  float: left;
  margin: 14px 0 0 14px;
  padding: 14px;
  transition: all 0.38s ease-out;
  border-radius: 6px;
}

.panel-group .card-panel-icon {
  float: left;
  font-size: 48px;
}
.panel-group .card-panel-description {
  float: right;
  font-weight: bold;
  margin: 26px;
  margin-left: 0px;
}
.panel-group .card-panel-text {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-bottom: 12px;
}

.panel-group .card-panel-num {
  display: block;
  font-size: 20px;
  text-align: right;
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
  .card-panel-icon-wrapper .svg-icon {
    display: block;
    margin: 14px auto !important;
    float: none !important;
  }
}
</style>